import { concatStyleSets, ILinkStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes, Transitions } from '../../themes/styles';

export const linkStylesDefault = (theme: IH2OTheme): ILinkStyles => ({
  root: {
    display: 'inline-flex',
    color: theme.semanticColors?.linkText,
    outline: 'none',
    textDecoration: 'underline',
    '.Link-icon': {
      marginRight: 8,
      fontSize: FontSizes.button,
    },
    '&.no-children': {
      '.Link-icon': {
        marginRight: 0,
      },
    },
  },
});

export const linkStylesBlack = (theme: IH2OTheme): ILinkStyles => ({
  root: {
    color: theme.semanticColors?.textPrimary,
    fontWeight: FontWeights.semiBold,
    fontSize: FontSizes.button,
    textDecoration: 'none',
  },
});

export const linkStylesBlackThin = (theme: IH2OTheme): ILinkStyles => ({
  root: {
    color: theme.semanticColors?.linkOverPrimary,
    fontSize: FontSizes.button,
    textDecoration: 'none',
  },
});

export const linkStylesIcon = (theme: IH2OTheme): ILinkStyles => ({
  root: {
    color: theme.semanticColors?.textSecondary,
    lineHeight: Sizes.height,
    textDecoration: 'none',
    '.Link-icon': {
      marginRight: 0,
      fontSize: FontSizes.large,
    },
  },
});

export const linkStylesGhost = (theme: IH2OTheme): ILinkStyles => ({
  root: {
    color: theme.semanticColors?.buttonGhostText,
    backgroundColor: theme.semanticColors?.buttonGhostBackground,
    border: `1px solid`,
    borderColor: theme.semanticColors?.buttonGhostBorder,
    borderRadius: Sizes.borderRadius,
    minHeight: Sizes.height - 2,
    lineHeight: Sizes.height - 2,
    padding: `0 ${Sizes.padding - 1}px`,
    fontSize: FontSizes.button,
    transition: `all ${Transitions.short}`,
    textDecoration: 'none',
    ':visited': {
      backgroundColor: theme.semanticColors?.buttonGhostBackground,
    },
    ':hover, :visited:hover': {
      backgroundColor: theme.semanticColors?.buttonGhostBackgroundHovered,
      borderColor: theme.semanticColors?.buttonGhostBorderHovered,
      color: theme.semanticColors?.buttonGhostTextHovered,
      textDecoration: 'none',
    },
    ':active, :active:hover, :active:visited': {
      backgroundColor: theme.semanticColors?.buttonGhostBackgroundActive,
      borderColor: theme.semanticColors?.buttonGhostBorderActive,
      color: theme.semanticColors?.buttonGhostTextActive,
      textDecoration: 'none',
    },
    ':focus, :focus:hover, :focus:visited': {
      backgroundColor: theme.semanticColors?.buttonGhostBackgroundFocused,
      borderColor: theme.semanticColors?.buttonGhostBorderFocused,
      color: theme.semanticColors?.buttonGhostTextFocused,
      textDecoration: 'none',
    },
    '&.is-disabled, &.is-disabled:focus, &.is-disabled:active': {
      backgroundColor: theme.semanticColors?.buttonGhostBackgroundDisabled,
      borderColor: theme.semanticColors?.buttonGhostBorderDisabled,
      color: theme.semanticColors?.textDisabled,
      pointerEvents: 'none',
    },
  },
});

export const linkStylesGhostIconOnly = (theme: IH2OTheme): ILinkStyles =>
  concatStyleSets(linkStylesGhost(theme), {
    root: { padding: '0 8px' },
  });

export const linkStylesPrimary = (theme: IH2OTheme): ILinkStyles =>
  concatStyleSets(linkStylesGhost(theme), {
    root: {
      color: theme.semanticColors?.buttonPrimaryText,
      fontWeight: FontWeights.medium,
      backgroundColor: theme.semanticColors?.buttonPrimaryBackground,
      borderColor: theme.semanticColors?.buttonPrimaryBackground,
      ':visited': {
        backgroundColor: theme.semanticColors?.buttonPrimaryBackground,
      },
      ':hover, :visited:hover': {
        backgroundColor: theme.semanticColors?.buttonPrimaryHoverBackground,
        borderColor: theme.semanticColors?.buttonPrimaryHoverBackground,
        color: theme.semanticColors?.buttonPrimaryText,
      },
      ':active, :active:hover, :active:visited, :focus, :focus:hover, :focus:visited': {
        backgroundColor: theme.semanticColors?.buttonPrimaryActiveBackground,
        borderColor: theme.semanticColors?.buttonPrimaryActiveBorder,
        color: theme.semanticColors?.buttonPrimaryText,
      },
      '&.is-disabled, &.is-disabled:focus, &.is-disabled:active': {
        backgroundColor: theme.semanticColors?.buttonPrimaryDisabledBackground,
        borderColor: theme.semanticColors?.buttonPrimaryDisabledBorder,
        color: theme.semanticColors?.buttonPrimaryDisabledText,
      },
    },
  });

export const linkStylesWidgetPanel = (theme: IH2OTheme): ILinkStyles => ({
  root: {
    color: theme.semanticColors?.textSecondary,
  },
});
